import React, {useEffect, useRef} from 'react';
import './Minicart.less';
import {CheckoutButton} from '../checkout-button/CheckoutButton';

import ScrollHelper from "helpers/scroll.helper";
import {convertPrice} from "helpers/format.helper";
import {CartDisplay} from 'compositions/cart-display/CartDisplay';

//TODO add edit animation

export const MINICART_POPUP = 'MINICART_POPUP';

export const Minicart = ({
													 cartItems = [],
													 totalPrice,
													 discount,
													 delivery,
													 cashpoints,
													 cashpointsName,
													 tip,
													 onCheckoutClick,
													 onQuantityDecClick,
													 onQuantityIncClick,
													 onModifierGroupClick,
												 }) => {

	const containerElement = useRef(null);

	useEffect(() => {
		if (!containerElement.current) return;

		let scroll = null;

		setTimeout(() => {
			scroll = ScrollHelper.initIScroll(containerElement.current, {
				scrollX: false,
				scrollY: true,
			});
		}, 0);

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return (
		<div className="minicart">
			<div className="minicart__items" ref={containerElement}>
				<div className="minicart__items-wrapper">
					{
						cartItems.length > 0 && (
							<CartDisplay
								cartItems={cartItems}
								onQuantityDecClick={onQuantityDecClick}
								onQuantityIncClick={onQuantityIncClick}
								onModifierGroupClick={onModifierGroupClick}
								discount={discount}
								delivery={delivery}
								cashpoints={cashpoints}
								cashpointsName={cashpointsName}
								tip={tip}
								isNoPaddings
							/>
						)
					}
				</div>
			</div>
			<div className="minicart__checkout">
				<CheckoutButton totalPrice={convertPrice(totalPrice)} onClick={onCheckoutClick} isEmpty={
					cartItems.length <= 0
				}/>
			</div>
		</div>
	);
};
